import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const PercentageIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M9.72315 8.46154C9.72315 9.82101 8.62107 10.9231 7.2616 10.9231C5.90212 10.9231 4.80005 9.82101 4.80005 8.46154C4.80005 7.10207 5.90212 6 7.2616 6C8.62107 6 9.72315 7.10207 9.72315 8.46154ZM19.2004 15.5416C19.2004 16.9011 18.0984 18.0032 16.7389 18.0032C15.3794 18.0032 14.2773 16.9011 14.2773 15.5416C14.2773 14.1821 15.3794 13.0801 16.7389 13.0801C18.0984 13.0801 19.2004 14.1821 19.2004 15.5416ZM15.3655 6H19.2L8.63456 18H4.80005L15.3655 6Z"
      />
    </SvgIcon>
  );
});
